import React, { Component } from 'react';
import { Card, Col, Row } from 'reactstrap'

export default class registrosCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }
        this.dateToString = this.dateToString.bind(this)
    }

    dateToString() {
        var date = new Date(this.props.fechaHora);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    render() {
        return (
            <div className="col-12">
                <Card className={this.props.encabezado ? "mb-1 col-12 py-2 bg-secondary text-white" : "mb-1 col-12 py-2"}>
                    <Row className="p-1 col-12 mx-1">
                        <Col sm="3"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Usuario" : this.props.usuario}</Col>
                        <Col sm="5"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Accion" : this.props.accion}</Col>
                        <Col sm="4"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Fecha y hora" : this.dateToString()}</Col>
                    </Row>
                </Card>
            </div>
        )
    }
}